import { all, call, put, takeLatest, select } from 'redux-saga/effects'
import CalendlyEventsAction, {
  CalendlyEventsTypes,
} from '../Redux/CalendlyEventRedux'
import BannerAction from '../Redux/BannerRedux'

export function* getAll(api) {
  const resp = yield call(api.getCalendlyEvents)
  if (resp.ok) {
    if (resp.data.status === 401) {
      yield put(
        CalendlyEventsAction.calendlyEventsListFailure(resp.data.message)
      )
      yield put(BannerAction.showInvalidCalendlyToken())
    } else {
      yield put(CalendlyEventsAction.calendlyEventsListSuccess(resp.data.data))

      if (resp.data.data.length === 0) {
        yield put(BannerAction.showNoEvents())
      } else {
        yield put(BannerAction.toggleBanner(false))
      }
    }
  } else {
    yield put(CalendlyEventsAction.calendlyEventsListFailure(resp.error))
    yield put(BannerAction.showInvalidCalendlyToken())
  }
}

export default function* authSagas(api) {
  yield all([
    takeLatest(CalendlyEventsTypes.CALENDLY_EVENTS_LIST_REQUEST, getAll, api),
  ])
}
